var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"pagination",attrs:{"background":true,"current-page":_vm.currentPage,"page-size":_vm.pageSize,"page-sizes":_vm.pageSizes,"total":_vm.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"current-change":_vm.onCurrentChange,"size-change":_vm.onSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }